import React, {useState} from 'react'
import {cx} from '../../../../../utils/classNameUtil'
import {WuButton} from '@npm-questionpro/wick-ui-lib'
import styles from './IdeationResultsComments.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {IDEATION} from '../../../../../Translation/English/ideation'
import type {IExploreIdea} from '../../../../../types'

interface IIdeationResultsCommentsProps {
  idea: IExploreIdea
  btnClassName?: string
  commentsBlockClassName?: string
}

export const IdeationResultsComments: React.FC<
  IIdeationResultsCommentsProps
> = ({idea, btnClassName, commentsBlockClassName}) => {
  const wt = useWt()
  const [isOpenComments, setIsOpenComments] = useState<boolean>(false)
  const comments = idea?.comments ?? []

  return (
    <div>
      <WuButton
        variant="secondary"
        className={cx(
          styles.btn,
          isOpenComments && styles.btnOpen,
          btnClassName,
        )}
        onClick={() =>
          comments.length > 0 ? setIsOpenComments(!isOpenComments) : {}
        }
      >
        {comments.length}{' '}
        {comments.length > 1
          ? String(wt(IDEATION.comments))
          : String(wt(IDEATION.comment))}
      </WuButton>

      <div
        className={cx(
          styles.commentsBlock,
          isOpenComments && styles.commentsBlockOpen,
          commentsBlockClassName,
        )}
      >
        {comments.map(comment => (
          <p key={comment.id} className={styles.comment}>
            {comment.comment}
          </p>
        ))}
      </div>
    </div>
  )
}
